import { errorLevel } from 'constants/errors';
import { treatErrorAs } from 'api/errors';
import { findTrialPlacements } from './finders';

export const requestTrialPlacements = () => {
  return (dispatch, getState) => {

    return Promise.resolve()
    .then(() => Promise.all([
      findTrialPlacements({ dispatch, getState })
      .catch(treatErrorAs({ severity: errorLevel.INFO }))
    ]));
  };
};